import { render } from "./TopSale.vue?vue&type=template&id=7f44802e"
import script from "./TopSale.vue?vue&type=script&lang=js"
export * from "./TopSale.vue?vue&type=script&lang=js"

import "./TopSale.vue?vue&type=style&index=0&id=7f44802e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__